import { CCol, CFormGroup, CRow } from "@coreui/react";
import React, { useCallback, useState } from "react";

import CurrencyField from "../currencies/CurrencyField";
import { PYG } from "../../currency/available-currencies";
import Product from "../../models/product";
import { withBrand } from "../../utils/brands";

interface ProductionLaborPriceFormProps {
  value: Product;
  onChange: (_: Product) => void;
  disabled?: boolean;
}

const DeliveryOrderDiscountItemForm: React.FC<
  ProductionLaborPriceFormProps
> = ({ value, onChange, disabled }) => {
  const [editingItem, setEditingItem] = useState<Product>(value);
  const [discount, setDiscount] = useState<number | undefined>(
    value.deliveryOrderDiscount
  );

  const onDiscountChange = useCallback(
    (newDiscount: number | undefined) => {
      setDiscount(newDiscount);
      const priceWithDiscount =
        (value.deliveryOrderPriceNoDiscount || 0) - (newDiscount || 0);

      const newItem = {
        ...editingItem,
        deliveryOrderDiscount: newDiscount,
        deliveryOrderPriceWithDiscount: priceWithDiscount,
      };
      setEditingItem(newItem);
      onChange(newItem);
    },
    [editingItem, onChange, value.deliveryOrderPriceNoDiscount]
  );

  return (
    <div className="section border rounded mb-2 p-2">
      <CFormGroup>
        <CRow>
          <CCol md={2} className={"mt-2"}>
            Producto:
          </CCol>
          <CCol md={3}>
            <p className={"mt-2"}>
              {withBrand(`${value.codeIdentifier} ${value.name}`, value.brandName)}
            </p>
          </CCol>
          <CCol md={2} className={"mt-2"}>
            Precio de orden:
          </CCol>
          <CCol md={2}>
            <CurrencyField
              currency={PYG}
              value={value.deliveryOrderPriceNoDiscount}
              disabled={true}
            />
          </CCol>
        </CRow>
        <CRow className="mt-2">
          <CCol md={2} className={"mt-2"}>
            Descuento por unidad:
          </CCol>
          <CCol md={3}>
            <CurrencyField
              currency={PYG}
              value={discount}
              onChange={onDiscountChange}
              placeholder="Descuento por unidad"
              disabled={disabled}
            />
          </CCol>
          <CCol md={2} className={"mt-2"}>
            Precio con descuento:
          </CCol>
          <CCol md={2}>
            <CurrencyField
              currency={PYG}
              value={value.deliveryOrderPriceWithDiscount}
              disabled={true}
            />
          </CCol>
        </CRow>
        {value.superWholesalePrice !== undefined && (
          <CRow className="mt-2">
            <CCol md={2} className={"mt-2"}>
              Referencia Precio Supermayorista:
            </CCol>
            <CCol md={2}>
              <CurrencyField
                currency={PYG}
                value={value.superWholesalePrice}
                disabled={true}
              />
            </CCol>
          </CRow>
        )}
      </CFormGroup>
    </div>
  );
};

export default DeliveryOrderDiscountItemForm;
